module.exports = __webpack_public_path__ + "img/account-icon-dark.4caad523.svg";